import React, { useState } from "react";
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";

export default function ChangePasswordModal({ show, onClose, user }) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const [error, setError] = useState("");

  if (!show) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (newPassword !== confirmPassword) {
      setError("New passwords do not match.");
      return;
    }

    setIsLoading(true);

    try {
      const response = await axios.put(
        `${ApiConnectionString}/api/account/password`,
        { currentPassword, newPassword },
        {
          headers: { Authorization: `bearer ${user.token}` },
        }
      );

      if (response.status === 200) {
        setIsComplete(true);
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
      }
    } catch (err) {
      console.error(err);
      setError("Unable to change password. Please check your current password.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setError("");
    setIsComplete(false);
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
    onClose();
  };

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title brand-purple">
                {isComplete ? "Password updated" : "Change password"}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
              ></button>
            </div>

            {/* SUCCESS STATE */}
            {isComplete ? (
              <div className="modal-body text-center py-4">
                <div className="alert alert-success mb-4">
                  Your password has been updated.
                </div>

                <p className="text-muted mb-4">
                  You can now close this window.
                </p>

                <button
                  className="btn brand-purple-inline"
                  onClick={handleClose}
                >
                  Close
                </button>
              </div>
            ) : (
              /* FORM STATE */
              <div className="modal-body">
                {error && <div className="alert alert-danger">{error}</div>}

                <form onSubmit={handleSubmit}>

                  {/* Current password */}
                  <div className="mb-3">
                    <label className="form-label fw-semibold brand-purple">
                      Current password
                    </label>
                    <div className="input-group">
                      <input
                        type={showCurrent ? "text" : "password"}
                        className="form-control"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        required
                      />
                      <button
                        type="button"
                        className="btn brand-purple-outline"
                        onClick={() => setShowCurrent(!showCurrent)}
                      >
                        {showCurrent ? "Hide" : "Show"}
                      </button>
                    </div>
                  </div>

                  {/* New password */}
                  <div className="mb-3">
                    <label className="form-label fw-semibold brand-purple">
                      New password
                    </label>
                    <div className="input-group">
                      <input
                        type={showNew ? "text" : "password"}
                        className="form-control"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                      />
                      <button
                        type="button"
                        className="btn brand-purple-outline"
                        onClick={() => setShowNew(!showNew)}
                      >
                        {showNew ? "Hide" : "Show"}
                      </button>
                    </div>
                  </div>

                  {/* Confirm new password */}
                  <div className="mb-3">
                    <label className="form-label fw-semibold brand-purple">
                      Confirm new password
                    </label>
                    <div className="input-group">
                      <input
                        type={showConfirm ? "text" : "password"}
                        className="form-control"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                      />
                      <button
                        type="button"
                        className="btn brand-purple-outline"
                        onClick={() => setShowConfirm(!showConfirm)}
                      >
                        {showConfirm ? "Hide" : "Show"}
                      </button>
                    </div>
                  </div>

                  <div className="modal-footer px-0">
                    <button
                      type="button"
                      className="btn brand-purple-outline"
                      onClick={handleClose}
                      disabled={isLoading}
                    >
                      Cancel
                    </button>

                    <button
                      type="submit"
                      className="btn brand-purple-inline"
                      disabled={isLoading}
                    >
                      {isLoading ? "Saving..." : "Save new password"}
                    </button>
                  </div>

                </form>
              </div>
            )}

          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  );
}
